export function getTextByYourRules(root: Element): string {
  return getTextByYourRules(root);
}

export function extractText(root: Element): string {
  let out = "";

  const isBlockLevel = (element: Element): boolean => {
    const display = getComputedStyle(element).display;

    switch (display) {
      case "inline":
      case "inline-block":
      case "inline-flex":
      case "inline-grid":
      case "contents":
        return false;

      default:
        return display !== "none";
    }
  };

  const append = (text: string) => {
    if (!text) {
      return;
    }

    // Normalize internal whitespace
    text = text.replace(/\s+/g, " ");

    // Avoid double spaces in join
    if (out.endsWith(" ") && text.startsWith(" ")) {
      text = text.slice(1);
    }

    out += text;
  };

  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      append(node.nodeValue ?? "");
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const el = node as Element;

    // Transform <br> into a space
    if (el.tagName === "BR") {
      append(" ");
      return;
    }

    const isBlock = isBlockLevel(el);

    // If the element is a block : we force a separation BEFORE if there is already text
    if (isBlock && out && !out.endsWith(" ")) {
      append(" ");
    }

    const children = Array.from(el.childNodes);
    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      walk(child);
    }

    // If it's a block, we also add a separation AFTER (separate the following blocks)
    if (isBlock && !out.endsWith(" ")) {
      append(" ");
    }
  };

  walk(root);

  // Final cleanup : compact and trim
  return out.replace(/\s+/g, " ").trim();
}
